export default class CTAModal {
    constructor(element) {
        var _a, _b;
        this.element = element;
        this.closeElement = (_a = this.element.querySelector("[data-cta-modal-close]")) !== null && _a !== void 0 ? _a : document.createElement("button");
        console.log(this.element.id);
        this.triggers = Array.from((_b = document.querySelectorAll(`[href="#${this.element.id}"]`)) !== null && _b !== void 0 ? _b : []);
        this.init();
    }
    init() {
        this.triggers.forEach((el) => el.addEventListener("click", this.open.bind(this)));
        this.closeElement.addEventListener("click", this.close.bind(this));
    }
    open(ev) {
        ev.preventDefault();
        document.documentElement.classList.add("modal-open");
        this.element.classList.add("modal-open");
    }
    close(ev) {
        ev.preventDefault();
        document.documentElement.classList.remove("modal-open");
        this.element.classList.remove("modal-open");
    }
}
